import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#006B46',
      dark: '#030183',
    },
    secondary: {
      main: '#19857b',
    },
    text: {
      primary: '#333',
      // Was '#fff' - invisible everywhere it's actually used (icons/labels on the app's own
      // light backgrounds - stat card labels, Account Info rows, input adornments), since
      // nothing in this light theme has a dark-enough background for white secondary text to
      // read against. Wherever text genuinely needs to be white-on-dark (e.g. the Profile hero
      // card), that's set as an explicit color on the spot instead of leaning on this.
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    // 'rgba(0, 107, 70, 0.1)'
    background: {
      default: '#fff',
      paper: '#ffffff'
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    // Scales every variant (body text, buttons, table cells, chips, menus, tooltips, etc.)
    // down from MUI's default of 14 - most page titles set their own explicit px size via
    // sx and are unaffected by this, this only pulls in the everyday UI chrome.
    fontSize: 13,
    h1: {
      fontSize: '2rem',
    },
    body1: {
      color: 'grey',
    },
    body2: {
      color: '#959684',
    },

  },
  transitions: {
    duration: {
      shortest: 150,
    },
    easing: {
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
  },
});

export default theme;
